import { apiDelete, apiGet, apiPost, apiPut, buildFormData } from '@api/api.utils'
import { IResponseAddressSuggestions, IResponseCommon } from "../common.types"
import {
    IResponseContractCard,
    IResponseContractCardPrograms,
    IResponseContractDocumentSendProgress,
    IResponseContractDocumentSendStart,
    IResponseContractFiles,
    IResponseContractInfo,
    IResponseContractPayments,
    IResponseContractProgramListenerSave,
    IResponseContractPrograms,
    IResponseContractReportCreate,
    IResponseContractReportProgress,
    IResponseContractReportFields,
    IResponseContractReports,
    IResponseContracts,
    IResponseContractsStatistics,
    IResponseNewContractNumber,
    IResponsePrimaryAccessPreview,
} from "./api.types"
import {
    IContractGenerateDocuments,
    IContractsFilter,
    IContractsFormSendedData,
    IContractsPaymentFormSendedData,
    IContractsProgramFormSendedData,
    IContractsProgramListenerFormSendedData,
} from "./state.types"


const route = '/contracts'

export const getContractGuardianAddressSuggestions = (query: string, signal?: AbortSignal): Promise<IResponseAddressSuggestions> =>
    apiPost<IResponseAddressSuggestions>(`${route}/getContractGuardianAddressSuggestions`, { signal }, { query })

/** Получение общей статистики */
export const getContractsStatistics = (): Promise<IResponseContractsStatistics> =>
    apiGet<IResponseContractsStatistics>(`${route}/getContractsStatistics`)



/** Получение списка договоров */
export const getContracts = (pageNumber: number, search?: string, filter?: IContractsFilter, signal?: AbortSignal): Promise<IResponseContracts> =>
    apiGet<IResponseContracts>(`${route}/getContracts`, {
        params: {
            pageNumber,
            search,
            ...(filter || {}),
        },
        signal,
    })
/** Получение списка оплат по договору */
export const getContractPayments = (contractID: number): Promise<IResponseContractPayments> =>
    apiGet<IResponseContractPayments>(`${route}/getContractPayments`, { params: { contractID } })
/** Получение списка програм и слушателей по договору */
export const getContractProgramsListeners = (contractID: number): Promise<IResponseContractPrograms> =>
    apiGet<IResponseContractPrograms>(`${route}/getContractProgramsListeners`, {
        params: {contractID, requestTime: Date.now()},
    })
/** Получение фактических программ LMS перед допуском к обучению */
export const getPrimaryAccessPreview = (contractID: number): Promise<IResponsePrimaryAccessPreview> =>
    apiGet<IResponsePrimaryAccessPreview>(`${route}/getPrimaryAccessPreview`, {params: {contractID}})
/** Получение списка файлов по договору */
export const getContractFiles = (contractID: number): Promise<IResponseContractFiles> =>
    apiGet<IResponseContractFiles>(`${route}/getContractFiles`, { params: { contractID } })
export const getContractReportFields = (): Promise<IResponseContractReportFields> =>
    apiGet<IResponseContractReportFields>(`${route}/getContractReportFields`)
export const getContractReports = (): Promise<IResponseContractReports> =>
    apiGet<IResponseContractReports>(`${route}/getContractReports`)
export const getContractReportProgress = (jobID: string): Promise<IResponseContractReportProgress> =>
    apiGet<IResponseContractReportProgress>(`${route}/getContractReportProgress`, {params: {jobID}})
export const setContractReportCreate = (search: string, filter: IContractsFilter, reportFields: string[]): Promise<IResponseContractReportCreate> =>
    apiPost<IResponseContractReportCreate>(
        `${route}/setContractReportCreate`,
        {params: {search, ...filter}},
        {reportFields, reportProgress: true},
    )
export const setContractReportDelete = (reportID: number): Promise<IResponseCommon> =>
    apiDelete<IResponseCommon>(`${route}/setContractReportDelete`, {params: {reportID}})




/** Получение данных по анкете договора */
export const getContractCard = (contractID: number): Promise<IResponseContractCard> =>
    apiGet<IResponseContractCard>(`${route}/getContractCard`, { params: { contractID } })
/** Изменение номера договора */
export const getNewContractNumber = (contractID: number, contractDate: string): Promise<IResponseNewContractNumber> =>
    apiGet<IResponseNewContractNumber>(`${route}/getNewContractNumber`, { params: { contractID, contractDate } })
/** Данные по анкете программы (Добавление / Редактирование программы по договору) */
export const getContractCardPrograms = (recordID: number, action: string): Promise<IResponseContractCardPrograms> =>
    apiGet<IResponseContractCardPrograms>(`${route}/getContractCardPrograms`, { params: { recordID, action } })
/** Сохранение данных по анкете программы договора */
export const setContractCardProgramsSave = (
    contractID: number,
    contractProgramID: number,
    data: IContractsProgramFormSendedData
): Promise<IResponseCommon> =>
    apiPut<IResponseCommon>(
        `${route}/setContractCardProgramsSave`,
        { params: { contractID, contractProgramID } },
        { contractProgramData: data }
    )
/** Сохранение данных по анкете программа-слушатель договора */
export const setContractCardProgramListenerSave = (
    contractListenerID: number,
    data: IContractsProgramListenerFormSendedData
): Promise<IResponseContractProgramListenerSave> =>
    apiPut<IResponseContractProgramListenerSave>(
        `${route}/setContractCardProgramListenerSave`,
        { params: { contractListenerID } },
        { contractProgramListenerData: data }
    )
/** Сохранение данных по анкете программа-слушатель договора */
export const setContractCardPaymentSave = (
    contractID: number,
    contractPaymentID: number,
    data: IContractsPaymentFormSendedData
): Promise<IResponseCommon> =>
    apiPut<IResponseCommon>(
        `${route}/setContractCardPaymentSave`,
        { params: { contractID, contractPaymentID } },
        { contractPaymentData: data }
    )
/** Удаление файлов по договору */
export const setContractFilesDelete = (contractID: number, fileID: number): Promise<IResponseCommon> =>
    apiDelete<IResponseCommon>(`${route}/setContractFilesDelete`, { params: { contractID, fileID } })
/** Загрузка файлов по договору */
export const setContractUploadFiles = (contractID: number, contractSectionID: number, files: File[]): Promise<IResponseCommon> =>
    apiPost<IResponseCommon>(
        `${route}/setContractUploadFiles`,
        {
            params: { contractID, contractSectionID },
            headers: { 'Content-Type': 'multipart/form-data' },
        },
        buildFormData({ docs: files })
    )
/** Сохранение данных по анкете договора */
export const setContractCardSave = (contractID: number, data: IContractsFormSendedData): Promise<IResponseContractSave> =>
    apiPut<IResponseContractSave>(`${route}/setContractCardSave`, { params: { contractID } }, { contractData: data })


/** Допуск к обучению и отправка информации в Telegram канал (ИКТ - Доступы в ЛК) */
export const setCreatePrimaryAccess = (contractID: number, isOutsideMoodle: number): Promise<IResponseCommon> =>
    apiPost<IResponseCommon>(`${route}/setCreatePrimaryAccess`, { params: { contractID, isOutsideMoodle } })
/** Формирование документов по договору */
export const setContractGenerateDocument = (
    contractID: number,
    documents: IContractGenerateDocuments[],
    paymentSum: string
): Promise<IResponseCommon> =>
    apiPost<IResponseCommon>(
        `${route}/setContractGenerateDocument`,
        { params: { contractID, paymentSum } },
        { documents }
    )
/** Отправка → Документы на подпись (Договор, Счёт, Заявление) → Telegram канал (ИКТ - Оформление договоров) */
export const setSendedContractDocuments = (contractID: number): Promise<IResponseCommon> =>
    apiPost<IResponseCommon>(`${route}/setSendedContractDocuments`, { params: { contractID }, timeout: 55000 })
export const startSendedContractDocuments = (contractID: number): Promise<IResponseContractDocumentSendStart> =>
    apiPost<IResponseContractDocumentSendStart>(`${route}/startSendedContractDocuments`, {params: {contractID}})
export const getContractDocumentSendProgress = (jobID: string): Promise<IResponseContractDocumentSendProgress> =>
    apiGet<IResponseContractDocumentSendProgress>(`${route}/getContractDocumentSendProgress`, {params: {jobID}})
/** Отправка → (Договор, Счёт, Заявление, Заявление на доставку) → Telegram канал (ИКТ - Переоформление договора) */
export const setSendedContractReissue = (contractID: number): Promise<IResponseCommon> =>
    apiPost<IResponseCommon>(`${route}/setSendedContractReissue`, { params: { contractID } })
/** Отправка заявления на доставку и счёта в срочный Telegram-канал сайта договора */
export const setSendedContractStatementDelivery = (contractID: number, isUrgent: number): Promise<IResponseCommon> =>
    apiPost<IResponseCommon>(`${route}/setSendedContractStatementDelivery`, { params: { contractID, isUrgent } })


/** Получение краткой информации для МИША ДЖЯН (WARNING GLOBAL) */
export const getContractInfo = (contractID: string): Promise<IResponseContractInfo> =>
    apiGet<IResponseContractInfo>(`${route}/getContractInfo`, { params: { contractID } })
/** Отказ от договора для МИША ДЖЯН (WARNING GLOBAL) */
export const setContractCanceled = (contractID: string, comment: string): Promise<IResponseCommon> =>
    apiPost<IResponseCommon>(`${route}/setContractCanceled`, undefined, { contractID, comment })